import styles from "./css/Popup.module.css";
import { UserInfo } from "../interfaces/chat.interface";

interface PopupProps {
  users: UserInfo[];
  onClose: () => void;
}

export default function Popup({ users, onClose }: PopupProps) {
  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.popup} onClick={(e) => e.stopPropagation()}>
        <h3>접속자 목록</h3>
        <div className={styles.userList}>
          {users.map((user, index) => (
            <div key={`p-${index}`} className={styles.userItem}>
              <div className={styles.userImage}>
                <img src={user.characterImageUrl} alt={user.nickname} />
              </div>
              <span className={styles.userName}>{user.nickname}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
